import type { ReactNode } from "react";

export function PageIntro({
  eyebrow,
  title,
  en,
  children,
}: {
  eyebrow?: string;
  title: string;
  en?: string;
  children?: ReactNode;
}) {
  return (
    <header className="page-intro fade-in">
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h1>
        {title}
        {en && <span>{en}</span>}
      </h1>
      {children}
    </header>
  );
}
